module.exports = __webpack_public_path__ + "img/plus.78921324.svg";